import chroma from 'chroma-js'

export function colorsFromList (values, colors = null, sort = true) {
  const filtered = Array.from(new Set(values))
  if (sort) {
    filtered.sort()
  }

  if (!colors) {
    colors = ['orange', '#2A4858']
  }

  const count = filtered.length
  const colorRange = chroma.scale(colors).colors(count)
  let colorMap = {}
  filtered.forEach((key, index) => {
    colorMap[key] = colorRange[index]
  })

  return colorMap
}

export function colorsFromObjectKeys (obj, colors = null, sort = true) {
  return colorsFromList(Object.keys(obj), colors, sort)
}

export function colorsFromObjectValues (obj, colors = null, sort = true) {
  return colorsFromList(Object.values(obj), colors, sort)
}

export function colorsFromObjectProp (prop, obj, colors = null, sort = true) {
  let values = []
  Object.keys(obj).forEach((key) => {
    const val = obj[key][prop]
    if (val !== undefined && val != null) {
      values.push(val)
    }
  })
  return colorsFromList(values, colors, sort)
}
